<template>
    <div class="user-info columns is-multiline">
        <div class="column is-12-tablet is-4-desktop is-12-widescreen">
            <b-panel :collapsible="true">
              <template #header>
                <strong>Info</strong>
              </template>

                <div class="content full-width">
                    <p class="between-center">
                        <strong>Project: </strong>
                        <span class="has-text-right">{{ projectNameById(task.project_id) }}</span>
                    </p>
                    <p class="between-center">
                        <strong>Service: </strong>
                        <span class="has-text-right">{{ projectServiceNameById(task.project_service_id)}}</span>
                    </p>
                    <p v-if="contactById(task.contact_id)" class="between-center">
                        <strong>Contact:</strong>
                        <router-link :to="`/companies/${contactById(task.contact_id).company_id}?contact_id=${task.contact_id}`" class="has-text-right">
                            {{ contactNameById(task.contact_id) }}
                        </router-link>
                    </p>
                    <p class="between-center">
                        <strong>Status: </strong>
                        <dropdown-quick-edit :entity="task" field="status" :update="partialUpdateTask" :options="taskStatuses" />
                    </p>
                    <p class="between-center">
                        <strong>Date Created:</strong>
                        <span class="has-text-right">{{ $filters.date(task.date_created) }}</span>
                    </p>
                    <p class="between-center">
                        <strong>Due Date:</strong>
                        <span class="has-text-right">{{ $filters.date(task.due_date) }}</span>
                    </p>
                    <p class="between-center">
                        <strong>Date Completed:</strong>
                        <span class="has-text-right">{{ $filters.valueOrDefault($filters.date(task.date_completed)) }}</span>
                    </p>
                    <template v-if="task.category_id == 1">
                        <p class="between-center">
                            <strong>Date Requested:</strong>
                            <span class="has-text-right">{{ $filters.date(task.date_requested) }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Date Sent:</strong>
                            <span class="has-text-right">{{ $filters.date(task.date_sent) }}</span>
                        </p>
                        <p class="between-center">
                            <strong>Date Received:</strong>
                            <span class="has-text-right">{{ $filters.date(task.date_received) }}</span>
                        </p>
                    </template>
                    <p class="between-center">
                        <strong>Created By: </strong>
                        <span class="has-text-right">{{ userNameById(task.creator_id) }}</span>
                    </p>
                    <p class="between-center">
                        <strong>Assigned To: </strong>
                        <span class="has-text-right">{{ userNameById(task.assignee_id) }}</span>
                    </p>
                    <p class="between-center">
                        <strong>Is activity package log: </strong>
                        <span class="has-text-right">{{ $filters.yesNo(task.is_package_log) }}</span>
                    </p>
                    <p v-if="task.category_id" class="between-center">
                        <strong>Category: </strong>
                        <span class="has-text-right">{{ task.category.name }}</span>
                    </p>
                    <p class="between-center">
                        <strong>Related To: </strong>
                        <router-link v-if="task.application_id" :to="applicationRoute" class="has-text-right">
                            {{ applicationNameByTypeAndId(task.application_type, task.application_id) }}
                        </router-link>
                        <span v-else class="has-text-right">-</span>
                    </p>
                    <p v-if="task.location" class="between-center">
                        <strong>Location:</strong>
                        <span style="max-width: 183px" class="has-text-right">{{ $filters.valueOrDefault(task.location_name, 'Unknown') }}</span>
                    </p>
                    <p v-if="task.last_editor_id" class="between-center">
                        <strong>Last edited by: </strong>
                        <router-link :to="`/users/${task.last_editor_id}`" class="has-text-right">
                            {{ userNameById(task.last_editor_id) }}
                        </router-link>
                    </p>
                    <p v-if="task.updated_at" class="between-center">
                        <strong>Updated at: </strong>
                        <span class="has-text-right">{{ $filters.date(task.updated_at) }}</span>
                    </p>
                </div>
            </b-panel>
        </div>
        <div class="column is-12-tablet is-4-desktop is-12-widescreen">
            <b-panel :collapsible="true">
              <template #header>
                <strong>Description </strong>
              </template>
                <div class="content full-width">
                    <div v-html="task.description"></div>
                </div>
            </b-panel>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        props: ['task'],

        computed: {
            ...mapGetters([
                'applicationNameByTypeAndId',
                'applicationTypes',
                'categoryNameById',
                'contactNameById',
                'projectNameById',
                'taskStatuses',
                'userNameById',
                'contactById',
                'projectServiceNameById'
            ]),

            applicationRoute() {
                return {
                    name: 'projects.show.applications',
                    params: {
                        applicationTypeParam: this.task.application_type,
                        applicationIdParam: this.task.application_id,
                        slug: this.task.project_id
                    }
                }
            }
        },

        methods: {
            ...mapActions(['partialUpdateTask'])
        }
    }
</script>
